module.exports = "/img/service-4.cca35e0a.png";